module.exports = __webpack_public_path__ + "img/thumbnail_PolarBear_j_normal.58685d61.png";